import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'dss-libs-ui-no-results',
  imports: [TranslocoDirective, MatIconModule],
  templateUrl: './no-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col items-center justify-center gap-6 bg-surface rounded-lg',
  },
})
export class NoResultsComponent {}
